import FormSection from '@/components/Forms/FormSection';
import { Box } from '@palmetto/palmetto-components';

import { InstallDocumentTypes, InstallPackageFileCategory } from 'types';

import { DocumentList } from '../../MilestonePackagePartials/Documents/DocumentList';

export const AhriCertificateSection = ({
  showCheckboxes,
  checkboxCategories,
  isPackageEditable = true,
  showUploadButton = true,
}: {
  showCheckboxes: boolean;
  checkboxCategories: InstallPackageFileCategory[];
  isPackageEditable?: boolean;
  showUploadButton?: boolean;
}) => {
  return (
    <FormSection
      title="AHRI Certificates"
      description={
        <Box gap="sm" fontSize="xs">
          <Box>Upload all AHRI Certificates for each system.</Box>
        </Box>
      }
    >
      <DocumentList
        documentTypeFilter={[InstallDocumentTypes.ahriCertificate]}
        title="AHRI Certificates"
        baseCategory={InstallDocumentTypes.ahriCertificate}
        grouped={false}
        showCheckboxes={showCheckboxes}
        checkboxCategories={checkboxCategories}
        isPackageEditable={isPackageEditable}
        showUploadButton={showUploadButton}
      />
    </FormSection>
  );
};
